import { Box, Drawer, Flex, Stack } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { useLkLayoutStore } from 'stores/local/layout/LkLayoutStore';

import { IconWithTitle } from '../IconWithTitle';
import LogoutButton from '../LogoutButton';
import Menu from '../Menu';
import { MenuBottomLinks } from '../MenuBottomLinks';
import SocialLinks from '../SocialLinks';
import TeamResponsible from '../TeamResponsible';

import s from './MobileDrawer.module.scss';

const MobileDrawer: React.FC = () => {
  const { menu } = useLkLayoutStore();

  return (
    <Drawer.Root className={s.root} opened={menu.isOpen} onClose={menu.close} size="100%">
      <Drawer.Content className={s.root__content}>
        <Drawer.Header className={s.root__header}>
          <IconWithTitle />
          <Drawer.CloseButton />
        </Drawer.Header>
        <Drawer.Body className={s['root__body']}>
          <Flex direction="column" gap="sm">
            <TeamResponsible />
            <Menu />
          </Flex>
          <Box>
            <Stack>
              <MenuBottomLinks />
              <SocialLinks />
            </Stack>
            <LogoutButton className={s.root__logout} />
          </Box>
        </Drawer.Body>
      </Drawer.Content>
    </Drawer.Root>
  );
};

export default observer(MobileDrawer);
